export const STATE_INPUT_LENGTH = 2;
